<div>
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="page_main_sec">
            <div class="row selection-sec">
                <div class="col-lg-3 doctype-wrap">
                    <span>
                        <small>Work Item Type</small>
                        <i class="material-icons" title="Edit"
                            (click)="isDisplayDocModel=true;isOpenDoctypeModel=true;showModal(documentTypeModal,'sm')">edit</i></span>
                    <br>
                    <span class="doctype-name">{{selectedDocumentType.docTypeName}}</span>
                </div>

                <div class="col-lg-6 work-item-btn-wrp text-end">
                    <a class="work-item-btn" [ngClass]="activeAllocationType==0?'active':''"
                        (click)="onSelected(0)">Allocation</a>
                    <a class="work-item-btn" [ngClass]="activeAllocationType==1?'active':''"
                        (click)="onSelected(1)">Reallocation</a>
                    <a class="work-item-btn" [ngClass]="activeAllocationType==2?'active':''"
                        (click)="onSelected(2)">View</a>

                    <!-- <div class="selectionBox" [ngClass]="activeAllocationType==0?'activeBox':''"
                        (click)="onSelected(0)">
                        Allocation
                    </div> -->
                </div>
                <!-- <div class="col-lg-2">
                    <div class="selectionBox" [ngClass]="activeAllocationType==1?'activeBox':''"
                        (click)="onSelected(1)">
                        Re-Allocation
                    </div>
                </div>
                <div class="col-lg-2">
                    <div class="selectionBox" [ngClass]="activeAllocationType==2?'activeBox':''"
                        (click)="onSelected(2)">
                        View
                    </div>
                </div> -->
            </div>
            <div *ngIf="activeAllocationType==0 || activeAllocationType==1" class="row selection-sec">
                <div class="row">
                    <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="process">Process <span class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedProcess" (selectionChange)="onSelectProcess($event.value)"
                                (click)="searchText_ProcessType.focus()" (focus)="searchText_ProcessType.focus()"
                                (closed)="searchText_ProcessType.value=''" id="process">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText_ProcessType
                                    autocomplete="off" class="mat-select-search" placeholder="Select User">
                                <mat-option [value]="option"
                                    *ngFor="let option of lstProcess| listFilter:{'name':searchText_ProcessType.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="txtRange">Record Range<span class="field-mandatory">*</span> </mat-label>
                            <input matInput id="txtRange" [(ngModel)]="strRange" placeholder="1-9999999">

                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="role_selection">Role Selection <span
                                    class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedRole" (selectionChange)="onSelectRole($event.value)"
                                (click)="searchText_RoleType.focus()" (focus)="searchText_RoleType.focus()"
                                (closed)="searchText_RoleType.value=''" id="role_selection">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText_RoleType
                                    autocomplete="off" class="mat-select-search" placeholder="Select User">
                                <mat-option [value]="option"
                                    *ngFor="let option of lstRole| listFilter:{'name':searchText_RoleType.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- <div class="col-lg-3" *ngIf="selectedRole.id>0 && activeAllocationType==1">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label>Currently Assigned To <span class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedAssigned"
                                (selectionChange)="onSelectAssigned($event.value)">
                                <mat-option [value]="a" *ngFor="let a of lstAssigned">
                                    {{a.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->
                    <div class="col-lg-3" *ngIf="activeAllocationType==1">
                        <app-dropdown-multiselect #ddlAssignedTo [lstDropdownOption]="lstAssigned" [isMandetory]="1"
                            [labelText]="'Currently Assigned To'" [allSelected]="true"
                            (Raise_event_selection_changed)="onAssignedToChange($event)">
                        </app-dropdown-multiselect>

                    </div>


                </div>

                <div class="row">
                    <div class="col-lg-12 text-end">
                        <button type="button" class="btncss me-2 btn_primary" (click)="getOpenSearchData();">
                            Search
                        </button>
                        <button type="button" class="btncss me-2 btn_secondary" (click)="ClearOpenSearch()">
                            Clear
                        </button>


                    </div>
                </div>


            </div>

            <div *ngIf="activeAllocationType==0 || activeAllocationType==1" class="row selection-sec">

                <div class="row">
                    <div class="col-lg-3" *ngIf="activeAllocationType==1">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="re_assign">Re-Assign To <span class="field-mandatory">*</span></mat-label>

                            <mat-select (click)="searchText.focus()" (closed)="searchText.value=''"
                                (focus)="searchText.focus()" [(ngModel)]="selectedReAssigned" id="re_assign">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText autocomplete="off"
                                    class="mat-select-search" placeholder="Search">
                                <ng-container *ngIf="lstReAssigned.length>0">
                                    <mat-option (onSelectionChange)="onSelectReAssigned(r)" [value]="r"
                                        *ngFor="let r of lstReAssigned | listFilter:{'name':searchText.value}">
                                        {{r.name}}
                                    </mat-option>
                                </ng-container>

                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3" *ngIf="activeAllocationType==0">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="associate_selection">Select Associate <span
                                    class="field-mandatory">*</span></mat-label>
                            <mat-select (click)="searchText.focus()" (closed)="searchText.value=''"
                                (focus)="searchText.focus()" [(ngModel)]="selectedAssociate"
                                (selectionChange)="onSelectAssociate($event.value)" id="associate_selection">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText autocomplete="off"
                                    class="mat-select-search" placeholder="Search">
                                <ng-container *ngIf="lstAssociate.length>0">
                                    <mat-option [value]="a"
                                        *ngFor="let a of lstAssociate | listFilter:{'name':searchText.value}">
                                        {{a.name}}
                                    </mat-option>
                                </ng-container>
                            </mat-select>

                        </mat-form-field>
                    </div>
                    <div class="col-lg-3">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="priority">Set Priority
                                <!-- <span class="field-mandatory">*</span> -->
                            </mat-label>
                            <mat-select [(ngModel)]="selectedPriority" (click)="searchText_RoleType.focus()"
                                (focus)="searchText_RoleType.focus()" (closed)="searchText_RoleType.value=''"
                                id="priority">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText_RoleType
                                    autocomplete="off" class="mat-select-search" placeholder="Select User">
                                <mat-option [value]="option"
                                    *ngFor="let option of lstPriority| listFilter:{'name':searchText_RoleType.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="row">
                        <div class="col-lg-12 text-end">
                            <button class=" btncss me-2 btn_primary" [class.btn_disable]="isDisabledAllocationButton"
                                [class.btn_primary]="!isDisabledAllocationButton" (click)="onSubmitButtonClick()"
                                [disabled]="isDisabledAllocationButton">{{buttonText}}</button>
                        </div>
                    </div>

                </div>

            </div>


            <div *ngIf="isShowAllocationList" class="row selection-sec">
                <app-advance-gridview [lstData]="lstProcessData" [lstHeaders]="lstHeaders" #gridTransactionData
                    [currentPage]="currentPage" [recordsPerPage]="recordsperPage" [gridTitle]="'Allocation List'"
                    [showColumnGroup]="true" [showAdvanceSearchOption]="true"
                    [advanceSearchFields]="advanceSearchSummaryFields" [showExcelDownloadOption]="true"
                    (cellClickEvent)="cellClickEvent($event)"
                    (advanceSearchClickEvent)="advanceSearchClickEvent($event)"
                    (setPaginationLocalStorageEvent)="setPaginationLocalStorageEvent()"
                    (columnsFilterChangeEvent)="columnsFilterChangeEvent($event)">
                </app-advance-gridview>
                <!-- <app-basic-gridview [lstData]="lstProcessData" [gridTitle]="'Allocation List'" [columnsToHide]="allocationColumnsToHide"
                    [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true"
                    [showPagination]="true" (cellClickEvent)="cellClickEvent($event)"></app-basic-gridview> -->
            </div>
        </div>




    </div>
</div>

<ng-template #documentTypeModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Work Item Type</h5>
            <button type="button" class="close model_close_btn"
                (click)="isOpenDoctypeModel = false;modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <ul class="selection-list">
                    <li [class.selected]="selectedDocumentType.docTypeId == docType.docTypeId"
                        *ngFor="let docType of docTypeList" (click)="onChangeDoctype(docType)">
                        <div class="selected-check">{{ docType.docTypeName }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>
<!-- 
<div *ngIf="isDisplayDocModel" class="doctype-model" [class.doctype-model-closed]="!isOpenDoctypeModel">
    <div class="bx">
        <div class="title-wrap">
            <p>Document Type</p>
            <button mat-icon-button class="dialog-close-button" (click)="isOpenDoctypeModel=false">
                <mat-icon class="close-icon" color="warn">close</mat-icon>
            </button>
        </div>
        <ul class="selection-list">
            <li [class.selected]="selectedDocumentType.docTypeId == docType.docTypeId"
                *ngFor="let docType of docTypeList" (click)="onChangeDoctype(docType)">
                <div class="selected-check">{{docType.docTypeName}}</div>
            </li>
        </ul>
    </div>
</div> -->

<app-transaction-lite></app-transaction-lite>